import React, { useContext } from 'react';
import styled, { css } from 'styled-components';
import { Field, useField } from 'react-final-form';
import {
  Avatar,
  FlexColumn,
  FlexMiddle,
  FlexSpace,
  ImageField,
  InputField,
  PlacesAutocomplete,
  ToggleField
} from '@ubeya/shared-web/components';
import { media } from '@ubeya/shared-web/style';
import { required } from '@ubeya/shared/utils/form';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import useUser from '@ubeya/shared/hooks/auth/useUser';

const AdminBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.4;
  background-color: ${({ theme }) => theme.colors.yellowLight};
  color: ${({ theme }) => theme.colors.orangeChanges};
  border: 1px solid ${({ theme }) => theme.colors.orangeChanges};
  white-space: nowrap;
`;

const SideBar = styled(FlexColumn)`
  align-items: center;
  flex: 1;
  ${({ $full }) =>
    $full
      ? css`
          padding: 2% 10%;
        `
      : css`
          padding-top: 34px;
        `}

  background: ${({ theme }) => theme.colors.white};
  ${media.tablet`
    border-right: 1px solid ${({ theme }) => theme.colors.grey2};
  `}
`;

const Container = styled(FlexSpace)`
  flex-wrap: wrap;
  padding: 0 40px 40px 40px;
  background: ${({ theme }) => theme.colors.white};

  > div {
    width: 100%;
    padding-top: 20px;
  }
`;

const Profile = ({ editMode }) => {
  const { t, isHost } = useContext(ConfigContext);
  const { isUbeyaAdmin } = useUser();

  const {
    input: { value: name }
  } = useField('name');
  const {
    input: { value: image }
  } = useField('image');
  const {
    input: { value: isDeleted }
  } = useField('isDeleted');

  return (
    <>
      <SideBar $full={!editMode}>
        {!isDeleted && !editMode ? <ImageField name="logo" /> : <Avatar firstName={name} image={image} size="large" />}

        <Container>
          <InputField name="name" title={t('name')} validate={required} required autoFocus isDisabled={editMode} />

          {editMode ? (
            <InputField name="location.address" isDisabled={editMode} title={t('address')} />
          ) : (
            <Field
              name="location"
              render={({ input, meta }) => (
                <PlacesAutocomplete
                  title={t('address')}
                  {...input}
                  value={input.value?.address || ''}
                  onChange={(address, location) => input.onChange({ ...input.value, address, name, ...location })}
                  error={meta.touched && meta.error}
                  clearable
                />
              )}
            />
          )}
        </Container>

        {isUbeyaAdmin && !isHost && (
          <Container>
            <ToggleField
              name="isClientControlsRates"
              title={
                <FlexMiddle style={{ gap: 8 }}>
                  <span>{t('isClientControlsRates')}</span>
                  <AdminBadge>Ubeya admin only</AdminBadge>
                </FlexMiddle>
              }
            />
          </Container>
        )}
      </SideBar>
    </>
  );
};

export default Profile;
